import template from './loansSignUpFormSimulationHousingChangeWarning.html';
import './loansSignUpFormSimulationHousingChangeWarning.scss';

let loansSignUpFormSimulationHousingChangeWarningComponent = {
  restrict: 'E',
  bindings: {
    simulationWitness: '<'
  },
  template
};

export default loansSignUpFormSimulationHousingChangeWarningComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpFormSimulation/loansSignUpFormSimulationHousingChangeWarning/loansSignUpFormSimulationHousingChangeWarning.component.js